import React, { useState } from "react";
import { Menu, ChevronDown, ChevronUp, Headphones, PhoneCall } from "react-feather";
import svg5 from "./img/svg5.svg";


const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What is the purpose of this website?",
      answer:
        "This website is designed to connect buyers and sellers for industrial machinery and parts.",
    },
    {
      question: "How do I sign up as a seller?",
      answer:
        "Click on the signup button and provide the required information. Our team will verify your details before activating your account.",
    },
    {
      question: "What payment methods are accepted?",
      answer:
        "We accept major credit cards, PayPal, and international payment gateways. Please refer to our payment methods page for more details.",
    },
    {
      question: "How can I contact customer support?",
      answer:
        "You can reach our customer support via the contact form or by calling our support number available on the Contact Us page.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <section className="faq-section bg-light pt-5">
        <div className="container">
            <div className="row g-0">
                <div className="col-md-8">
                <div className="text-start mb-4">
            <h1>FAQs</h1>
            <p>Find answers to the most commonly asked questions below.</p>
          </div>


          <div className="accordion">
            {faqs.map((faq, index) => (
              <div
                className={`accordion-item ${activeIndex === index ? "active" : ""}`}
                key={index}
              >
                <div
                  className="accordion-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <h5><span><img src={svg5} className="img-fluid"/></span> {faq.question}</h5>
                  <span className="accordion-icon">
                    {activeIndex === index ? <ChevronUp/>  : <ChevronDown/>}
                  </span>
                </div>
                <div
                  className="accordion-body"
                  style={{
                    maxHeight: activeIndex === index ? "100px" : "0",
                  }}
                >
                  <p className="p1 text-start">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>



                </div>
            </div>
          
          
        </div>
      </section>
    </>
  );
};

export default Faq;
